import { Field }                       from '$/entities/lib/JSONable';
import BasePreferences, { Preference } from '$/entities/lib/BasePreferences';
import { BaseRolePreferences }         from '$/entities/roles/BaseRole';

export enum LandlordEmailKeys {
	LandlordNoLogin            = 'landlordNoLogin',
	LandlordMonthlyEmail       = 'landlordMonthlyEmail',
	DataContributorSecondEmail = 'dataContributorSecondEmail',
}

export class LandlordPreferences extends BaseRolePreferences {

	@Field()
	emails: Partial<Record<LandlordEmailKeys, Preference>> = {};

}

export enum LandlordInterestTypes {
	RecoverDebt   = 'recoverDebt',
	BuildCredit   = 'buildCredit',
	PullCredit    = 'pullCredit',
	RecordKeeping = 'recordKeeping',
	EnsureRent    = 'ensureRent',
}

export class LandlordInterests extends BasePreferences {

	@Field()
	[LandlordInterestTypes.RecoverDebt]?: boolean;

	@Field()
	[LandlordInterestTypes.BuildCredit]?: boolean;

	@Field()
	[LandlordInterestTypes.PullCredit]?: boolean;

	@Field()
	[LandlordInterestTypes.RecordKeeping]?: boolean;

	@Field()
	[LandlordInterestTypes.EnsureRent]?: boolean;

}
